import React from 'react';
import {
  Image,
  SafeAreaView,
  ScrollView,
  StatusBar,
  TouchableOpacity,
  View,
  Text,
  Platform,
} from 'react-native';
import MarisaLogoSVG from '~/credsystem/assets/svgs/marisa-logo-pink.svg';
import useAppNavigation from '~/hooks/useAppNavigation';
import CloseSVG from '~/assets/svgs/close.svg';
import colors from '~/assets/themes/colors';
import MarisaCard from '~/credsystem/assets/imgs/marisa-card.png';
import DefaultScreenContainerView from '~/components/DefaultScreenContainerView';

const About: React.FC = () => {
  const { goBack } = useAppNavigation();

  return (
    <SafeAreaView className="flex-1 bg-light-100">
      <StatusBar barStyle="light-content" backgroundColor={colors.light[100]} />
      <DefaultScreenContainerView>
        <View className="p-6 flex-1 bg-light-100">
          <View className="mb-6 flex-row justify-between">
            <MarisaLogoSVG />
            <TouchableOpacity onPress={goBack}>
              <CloseSVG
                className="self-center"
                height={24}
                width={24}
                color={colors.gray[400]}
              />
            </TouchableOpacity>
          </View>
          <ScrollView
            contentContainerStyle={{
              paddingBottom: 18,
            }}
            showsVerticalScrollIndicator={false}
          >
            <View className="ml-10 mt-6 w-28 h-28 bg-primary-500 rounded-full mb-6 items-center justify-center">
              <Image
                className="w-[170px] h-[135px] -ml-4"
                source={MarisaCard}
              />
            </View>
            <Text className="font-semibold text-dark-500 mb-5 text-lg">
              Para melhorar cada vez mais a sua experiência como cliente do
              nosso cartão, a Marisa fez uma parceria com a Credsystem
            </Text>
            <Text className="text-dark-400 mb-12 text-[18px]">
              {`Fundada há 27 anos e com atuação nacional, a Credsystem é a maior empresa especializada em oferecer ao varejo soluções de cartões de crédito e outros serviços financeiros.\n\n`}
              {`Se precisar consultar suas compras realizadas até 08/11/2023, pode continuar acessando por aqui.\n\n`}
              {`Se suas compras foram realizadas a partir do dia 08/11, você pode ter acesso a saldo, fatura e limite baixando o novo aplicativo Cartão Marisa, disponível no Google Play e App Store.`}
            </Text>
          </ScrollView>
        </View>
      </DefaultScreenContainerView>
      {Platform.OS !== 'web' && (
        <View className="border-t-[1px] border-light-200 bg-light-100 px-6">
          <TouchableOpacity
            className="w-full bg-primary-600 py-4 rounded-lg my-4"
            onPress={goBack}
          >
            <Text className="text-light-100 text-sm text-center">FECHAR</Text>
          </TouchableOpacity>
        </View>
      )}
    </SafeAreaView>
  );
};

export default About;
